export const UserRole = {
  HR: "HR",
  ADMIN: "Admin",
  USER: "User",
};
